<template>
  <div class="content mb-5">
    <t-sub-nav
      class="mb-5"
      :loading="loading"
      :items="$secondaryNav.customerGroupNavItems()"
    />
    <b-row class="mb-5 group_grid">
      <b-col>
        <div v-if="empty && !loading" class="group_row">
          {{
            this.$t("No groups found. Only groups with policies can be ranked.")
          }}
        </div>
        <draggable v-model="form.items" v-if="!empty" draggable=".group_row">
          <div slot="header" class="group_row_header">
            <span class="group_item_name">{{ this.$t("Group Name") }}</span>
            <span class="group_item_policy">{{ this.$t("Policy") }}</span>
            <span class="group_item_users">{{ this.$t("Users") }}</span>
          </div>
          <div
            class="group_row"
            v-for="group in form.items"
            :key="group.name"
            :title="$t('Click and drag to reorder groups')"
            @dragstart="onDragStart"
            @dragend="onDragEnd"
          >
            <span class="group_item_name">{{ group.name }}</span>
            <span class="group_item_policy">{{ group.policy_name }}</span>
            <span class="group_item_users">{{ group.users }}</span>
          </div>
          <div slot="footer" class="group_row_footer">
            <b-button
              class="group_button"
              data-test-id="groups-ranking-save"
              @click="onSubmit"
              >{{ this.$t("Save") }}</b-button
            >
          </div>
        </draggable>
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
"name": "Customer Ranking Groups"
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";
import draggable from "vuedraggable";

export default {
  layout: "customer",
  components: {
    draggable,
  },
  data: function () {
    return {
      loading: true,
      empty: true,
      form: {
        items: [],
      },
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("groups", [
      "fetchCustomerGroups",
      "updateCustomerGroupsWeight",
    ]),
    onDragStart(e) {
      e.target.classList.add("dragging");
    },
    onDragEnd(e) {
      e.target.classList.remove("dragging");
    },
    async onSubmit() {
      try {
        await this.updateCustomerGroupsWeight({
          userId: this.selectedUser.id,
          groups: this.form.items,
        });
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Group Ranking updated successfully"),
          duration: 2000,
          variant: "success",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("groups", ["groups"]),
    ...mapGetters("authentication", ["selectedUser"]),
  },
  watch: {
    groups() {
      this.form.items = this.groups.filter((group) => group.policy_id !== null);
      this.empty = this.form.items.length <= 0;
    },
  },
  async created() {
    this.setPageTitle(this.$t("Groups"));
    this.setPageSubtitle([
      this.$t(
        "Drag and drop to rank groups. If a user is in more than one group, the group higher on the list takes precedence. Only groups with polices are listed."
      ),
    ]);
    try {
      await this.fetchCustomerGroups({ id: this.selectedUser.id });
    } finally {
      this.loading = false;
    }
  },
};
</script>
<style scoped lang="scss">
.group_grid {
  background-color: #fff;
  border-radius: 4px;
  width: 98%;
  margin-left: auto;
  margin-right: auto;
}

.group_row {
  background-color: #fff;
  cursor: pointer;
  padding: 0 16px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  min-height: 56px;
  line-height: 3.5;
  display: flex;
}

.dragging {
  border: 2px solid rgba(0, 0, 0, 0.32);
}

.group_row_header {
  padding: 0 16px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  min-height: 56px;
  line-height: 3.5;
  display: flex;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.6);
}

.group_item_name {
  width: 50%;
}
.group_item_policy {
  width: 30%;
}
.group_item_users {
  width: 20%;
}

.group_row_footer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.group_button {
  margin-top: 5px;
}
</style>
